import './assets/main.scss'

import { createApp } from 'vue'
import * as Sentry from "@sentry/vue";
import App from './App.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faHashtag,
  faChevronRight,
  faChevronLeft,
  faCircleNotch,
  faEllipsis
} from '@fortawesome/free-solid-svg-icons'; // Import specific icons

import PrimeVue from 'primevue/config';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import ToggleSwitch from 'primevue/toggleswitch';
import TextArea from 'primevue/textarea';
import Image from 'primevue/image';
import Dialog from 'primevue/dialog';
import ConfirmDialog from 'primevue/confirmdialog';
import SpeedDial from 'primevue/speeddial';
import Drawer from 'primevue/drawer';
import Aura from '@primeuix/themes/aura'

import { register } from 'swiper/element/bundle';
import { definePreset } from '@primeuix/themes';
import { ConfirmationService } from 'primevue';
register();

library.add(faCheck, faHashtag, faChevronRight, faChevronLeft, faCircleNotch, faEllipsis);

const app = createApp(App);

const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

Sentry.init({
  app,
  dsn: SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: ENVIRONMENT
});

app.component('font-awesome-icon', FontAwesomeIcon);

const myPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{purple.50}',
      100: '{purple.100}',
      200: '{purple.200}',
      300: '{purple.300}',
      400: '{purple.400}',
      500: '{purple.500}',
      600: '{purple.600}',
      700: '{purple.700}',
      800: '{purple.800}',
      900: '{purple.900}',
      950: '{purple.950}'
    }
  }
});

app.use(PrimeVue, {
  theme: {
    preset: myPreset,
    options: {
      darkModeSelector: false || 'none',
    }
  },
});
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('ColumnGroup', ColumnGroup);
app.component('Row', Row);
app.component('InputText', InputText);
app.component('Button', Button);
app.component('ToggleSwitch', ToggleSwitch);
app.component('TextArea', TextArea);
app.component('Image', Image);
app.component('Dialog', Dialog);
app.component('ConfirmDialog', ConfirmDialog);
app.component('SpeedDial', SpeedDial);
app.component('Drawer', Drawer);
app.use(ConfirmationService);

app.mount('#app');
